import { Options } from 'vue-class-component';

import CommandWizardStep from '../CommandWizardStep';
import AddDeviceToLinkableObject from '@/views/components/AddDeviceToLinkableObject/AddDeviceToLinkableObject.vue';

import plantsClient from '@/core/services/plants';
import {
  AggregateCommandType,
  DeviceDTO,
  SlotStatus,
} from '@/../client-generator/generated-clients/plants';
import { mapState } from 'vuex';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { SlotRuleServiceType } from '@/core/services/slots-assign-rules-service/slots-assign-rules-interfaces';

@Options({
  name: 'CommandWizardStep3',
  components: {
    AddDeviceToLinkableObject,
  },
  computed: {
    ...mapState(['selectedPlantId']),
  },
  watch: {
    atLeastOneDeviceAndSlotSelected: function () {
      this.validateNextEnabled();
    },
  },
})
export default class CommandWizardStep3 extends CommandWizardStep {
  selectedPlantId!: number;
  devicesCommands: DeviceDTO[] = [];
  SlotRuleServiceType = SlotRuleServiceType;

  get currentDevicesCommands() {
    return this.commandGroup.devices?.filter((x) => x.isCommandDevice) ?? [];
  }

  mounted() {
    this.fetchDevices();
  }

  get atLeastOneDeviceAndSlotSelected() {
    return (
      this.commandGroup.devices?.some((k) =>
        k.slots?.some(
          (s) =>
            s.status == SlotStatus.MarkedForLinking ||
            (s.status == SlotStatus.Configured &&
              s.linkedObjects?.some((l) => l.id === this.commandGroup.id))
        )
      ) ?? false
    );
  }

  async fetchDevices() {
    this.$store.dispatch(SET_APP_LOADING, true);

    try {
      this.devicesCommands = await plantsClient.commandDevices(
        this.selectedPlantId,
        this.commandGroup.roomObjectType
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  validateNextEnabled() {
    this.nextEnabled =
      this.commandGroup.type == AggregateCommandType.Group ||
      this.atLeastOneDeviceAndSlotSelected;
  }
}
